export const FORGOT_PASSWORD = '/forgot-password';
export const LOGIN = '/login';
export const ORDERS = '/orders';
export const ORDER_DETAIL = '/orders/:id';

export function getPath(route, id = {}) {
  let url = route;
  const params = typeof id === 'object' ? id : { id };
  Object.keys(params).forEach(property => {
    url = url.replace(`:${property}`, params[property]);
  });
  return url;
}



// WEBPACK FOOTER //
// ./src/routes.js